<template>
  <vs-card>
    <vs-table hoverFlat stripe :data="categories" search pagination max-items="10">
      <template slot="header">
        <h3>
          Csoportok
        </h3>
        <vs-button radius color="success" type="gradient" icon="add" @click="addCategory()"></vs-button>
      </template>
      <template slot="thead">
        <vs-th>
          Megnevezés
        </vs-th>
        <vs-th>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.CategoryName }}
          </vs-td>
          <vs-td>
            <vs-row vs-type="flex" vs-align="right" vs-justify="flex-end">
              <vs-button radius color="warning" size="small" type="gradient" icon="build"
                         @click="editCategory(tr.Id)"></vs-button>
              <vs-button radius color="danger" size="small" type="gradient" icon="clear"
                         @click="delCategory(tr.Id)"></vs-button>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="centerx">
      <vs-popup classContent="addCategoryModal" title="Új csoport hozzáadása" :active.sync="addModal"
                @closemodal="closeModal()">
        <new_category v-bind:selected="selected"></new_category>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup classContent="editCategoryModal" title="Csoport módosítása" :active.sync="editModal"
                @closemodal="closeModal()">
        <edit_category v-bind:selected="selected"></edit_category>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import {axiosInstance} from "@/main";
import new_category from "../../components/modals/new_category";
import edit_category from "../../components/modals/edit_category";

export default {
  name: "categories",
  data() {
    return {
      categories: [],
      editModal: false,
      addModal: false,
      selected: {
        Id: '',
        CategoryName: '',
      }
    }
  },
  components: {
    new_category, edit_category
  },
  methods: {
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.getCategories();
    },
    getCategories() {
      let self = this;
      axiosInstance
          .get('admin/categoryController.php', {
            withCredentials: true,
          })
          .then((response) => {
            this.categories = response.data.responseData;
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus();
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    addCategory() {
      this.selected.CategoryName = '';
      this.addModal = true;
    },
    editCategory(id) {
      this.selected = {...this.categories.find(elem => elem.Id === id)};
      this.editModal = true;
    },
    delCategory(id) {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Megerősítés`,
        text: 'Valóban törölni kívánja a csoportot?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .delete('admin/categoryController.php?id=' + id, {
                withCredentials: true,
              })
              .then((resp) => {
                self.getCategories();
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres törlés.' : 'Sikertelen törlés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus();
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    }
  },
  created() {
    this.getCategories();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

form {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

.vs-button {
  margin: 1px 5px;
}

</style>